import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d0d005f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "User", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Please select...", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "columns strat1 s-card is-mobile mx-0 my-5" }
const _hoisted_5 = { class: "column strat1" }
const _hoisted_6 = { class: "flex-table" }
const _hoisted_7 = { class: "flex-table-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Group ", -1))
const _hoisted_9 = { style: {"color":"#a9abac","font-weight":"bold"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cell-end" }, [
  /*#__PURE__*/_createTextVNode("Drag to right "),
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "lnir lnir-shift-right"
  })
], -1))
const _hoisted_11 = { class: "flex-list-inner" }
const _hoisted_12 = { class: "flex-table-cell" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-table-cell cell-end",
  "data-th": ""
}, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "lnir lnir-shift-right"
  })
], -1))
const _hoisted_14 = { class: "column strat1" }
const _hoisted_15 = { class: "flex-table" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-table-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "lnir lnir-shift-left"
    }),
    /*#__PURE__*/_createTextVNode(" Drag to left")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "cell-end" }, "Custom Strats ")
], -1))
const _hoisted_17 = { class: "flex-list-inner" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-table-cell" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "lnir lnir-shift-left"
  })
], -1))
const _hoisted_19 = {
  class: "flex-table-cell cell-end",
  "data-th": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.user.is_staff==true)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(_ctx.select)
        }, [
          _createElementVNode("select", {
            class: "select",
            name: "creator",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fieldUpdate && _ctx.fieldUpdate(...args)))
          }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_groups, (group_data) => {
              return (_openBlock(), _createElementBlock("option", {
                key: group_data.id,
                value: group_data.id
              }, _toDisplayString(group_data.name), 9, _hoisted_3))
            }), 128))
          ], 32)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.group_data.name), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createVNode(_component_draggable, {
                ref: "AddtoList",
                style: {"width":"100%"},
                class: "dragArea list-group w-full",
                list: _ctx.AllStratsP,
                group: "stratsp"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AllStratsP, (element) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: element.strat_name,
                      class: "flex-table-item dragmove has-background-link"
                    }, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(element.strat_name), 1),
                      _hoisted_13
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createVNode(_component_draggable, {
                class: "dragArea list-group w-full",
                list: _ctx.CustomStratListP,
                group: "stratsp",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusChangeStrat('added', 3)))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CustomStratListP, (element) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: element.strat_name,
                      class: "flex-table-item dragmove has-background-info"
                    }, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, _toDisplayString(element.strat_name), 1)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}